import type { TypographyProps } from '@mui/material';
import { Box, Stack, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

export interface RowSeatInfoProps {
  row?: string | number | null;
  seat?: string | number | null;
  variant?: TypographyProps['variant'];
}

/**
 * Renders "Row {row} • Seat {seat}" where the separator is a styled dot rather
 * than a character baked into the translation. Row and seat are independent
 * translations (`common.rowNumber`, `common.seatNumber`) and either part is
 * omitted when its value is missing.
 */
export const RowSeatInfo = ({
  row,
  seat,
  variant = 'body2Medium',
}: RowSeatInfoProps) => {
  const hasRow = row != null && row !== '';
  const hasSeat = seat != null && seat !== '';

  return (
    <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
      {hasRow && (
        <Typography variant={variant}>
          <FormattedMessage
            id="common.rowNumber"
            defaultMessage="Row {row}"
            values={{ row }}
          />
        </Typography>
      )}
      {hasRow && hasSeat && (
        <Box
          sx={{
            width: 4,
            height: 4,
            borderRadius: '50%',
            bgcolor: 'text.disabled',
          }}
        />
      )}
      {hasSeat && (
        <Typography variant={variant}>
          <FormattedMessage
            id="common.seatNumber"
            defaultMessage="Seat {seat}"
            values={{ seat }}
          />
        </Typography>
      )}
    </Stack>
  );
};
